import React from 'react';

//@ts-ignore
import * as styles from './filtered-content.module.css';
import { ContentPreview } from './index';
import { FilteredContentProps } from './index';
import {
    getMultiChoice,
    getTimeToRead,
    optimizeKontentImageUrl,
    buildKontentSrcSet,
} from '../Global/DataUtils';
import { BlogPagePreview } from '../Global/DataUtils/blogQueries';
import LazyImage from '../Global/LazyImage';
import BlogSubscriptionForm from '../Global/BlogSubscriptionForm';
import CtaLink from '../Global/CtaLink';
import { getLangPrefix } from '../../global/countries';

interface Props {
    content?: ContentPreview[];
    preferredLanguage?: string;
    show_blog_subscription_form: FilteredContentProps['show_blog_subscription_form'];
    cta_label: FilteredContentProps['cta_label'];
    submit_cta_label: FilteredContentProps['submit_cta_label'];
    interested_in_field: FilteredContentProps['interested_in_field'];
    full_name_field: FilteredContentProps['full_name_field'];
    form_headline: FilteredContentProps['form_headline'];
    email_address_field: FilteredContentProps['email_address_field'];
    blog_topic: FilteredContentProps['blog_topic'];
    form_confirmation_message?: FilteredContentProps['form_confirmation_message'];
}

const BlogExploration: React.FC<Props> = ({
    content,
    preferredLanguage,
    cta_label,
    show_blog_subscription_form,
    submit_cta_label,
    interested_in_field,
    full_name_field,
    form_headline,
    email_address_field,
    blog_topic,
    form_confirmation_message,
}) => {
    const langPrefix = getLangPrefix(preferredLanguage);

    const renderPost = (contentItem: BlogPagePreview, contentIdx: number) => {
        const metadata =
            contentItem?.elements?.other_metadata?.value[0]?.elements;

        if (!metadata) {
            return null;
        }

        const url = `${langPrefix}${contentItem?.elements.slug.url}`;
        const relatedTags = contentItem?.elements.blog_topic.value;
        const timeToRead = getTimeToRead(contentItem as BlogPagePreview);

        const renderImages = () => {
            const exploreAllBlogsImages =
                metadata?.explore_all_blogs_image?.value;

            if (!exploreAllBlogsImages?.length) return null;

            const firstImage =
                exploreAllBlogsImages[0]?.elements?.file?.value[0];
            if (!firstImage?.url) return null;

            return (
                <div data-kontent-element-codename="explore_all_blogs_image">
                    <LazyImage
                        src={optimizeKontentImageUrl(firstImage.url, {
                            w: 1090,
                            fit: 'crop',
                            fm: 'webp',
                            q: 80,
                        })}
                        srcSet={buildKontentSrcSet(firstImage.url, 1090, {
                            fm: 'webp',
                            q: 80,
                            fit: 'crop',
                        })}
                        sizes="(max-width: 992px) 100vw, 50vw"
                        width={1090}
                        height={
                            firstImage.height && firstImage.width
                                ? Math.round(
                                      (1090 * firstImage.height) /
                                          firstImage.width
                                  )
                                : 600
                        }
                        alt={firstImage.description || firstImage.name || ''}
                        // Previously eager for every post; only the first
                        // post's image can be above the fold.
                        priority={contentIdx === 0}
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            );
        };

        return (
            <React.Fragment key={contentIdx}>
                <div className={styles.blogExploration}>
                    <div className={styles.featuredImage}>
                        {renderImages()}
                        {relatedTags && (
                            <span className={styles.relatedTags}>
                                {relatedTags.map((tag, tagIdx) => (
                                    <span
                                        className={styles.relatedTag}
                                        key={tagIdx}
                                    >
                                        {tag.name}
                                    </span>
                                ))}
                            </span>
                        )}
                    </div>
                    <div className={styles.blogContent}>
                        {timeToRead > 0 && (
                            <p className={styles.minuteReadTime}>
                                {timeToRead} minute read
                            </p>
                        )}
                        <div
                            className={styles.blogTitle}
                            data-kontent-element-codename="title"
                        >
                            {metadata?.title.value}
                        </div>
                        <p data-kontent-element-codename="short_description">
                            {metadata?.short_description.value}
                        </p>
                        <CtaLink
                            href={url}
                            target="_self"
                            color="#505251"
                            elementCodename="cta_label"
                        >
                            {cta_label?.value}
                        </CtaLink>
                    </div>
                </div>
            </React.Fragment>
        );
    };
    const blogFormShow =
        getMultiChoice(show_blog_subscription_form) === 'yes' &&
        form_headline?.value;

    return (
        <div>
            {content &&
                content.map((contentItem, itemIdx) => {
                    return renderPost(contentItem as BlogPagePreview, itemIdx);
                })}

            {/* {blogFormShow && (
                <div className={styles.subform}>
                    <BlogSubscriptionForm
                        headline={
                            form_headline?.value ? form_headline.value : ''
                        }
                        formConfirmationMessage={
                            form_confirmation_message? form_confirmation_message?.value
                                : ''
                        }
                        cta={
                            submit_cta_label?.value
                                ? submit_cta_label?.value
                                : ''
                        }
                        nameLabel={
                            full_name_field ? full_name_field?.value : ''
                        }
                        emailAddressLabel={
                            email_address_field
                                ? email_address_field?.value
                                : ''
                        }
                        blogTopics={blog_topic.value}
                        interestedFieldLabel={
                            interested_in_field
                                ? interested_in_field?.value
                                : ''
                        }
                        topics={[]}
                    />
                </div>
            )} */}
        </div>
    );
};

export default BlogExploration;
